import React from "react";
import Image from "next/image";
import { LadyContact } from "@/assets/images";
import Form from "./Form";

function Signup() {
  return (
    <section className="bg-white" id="signup">
      <div className="grid grid-cols-1 lg:grid-cols-2">
        <div className="relative flex items-end bg-gray-50 px-4 pb-10 pt-60 sm:px-6 sm:pb-16 md:justify-center lg:px-8 lg:pb-24">
          <div className="absolute inset-0">
            <Image
              src={LadyContact}
              alt="Join Leading CRE Capital Advisors & Take Your Deal-Making to the Next Level"
              fill
              sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 50vw"
              className="object-cover object-center"
              priority
              quality={75}
              placeholder="blur"
              blurDataURL="data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wBDAAYEBQYFBAYGBQYHBwYIChAKCgkJChQODwwQFxQYGBcUFhYaHSUfGhsjHBYWICwgIyYnKSopGR8tMC0oMCUoKSj/2wBDAQcHBwoIChMKChMoGhYaKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCj/wAARCAAIAAoDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAv/xAAhEAACAQMDBQAAAAAAAAAAAAABAgMABAUGIWGRkqGx0f/EABUBAQEAAAAAAAAAAAAAAAAAAAMF/8QAGhEAAgIDAAAAAAAAAAAAAAAAAAECEgMRkf/aAAwDAQACEQMRAD8AltJagyeH0AthI5xdrLcNM91BF5pX2HaH9bcfaSXWGaRmknyJckliyjqTzSlT54b6bk+h0R//2Q=="
              style={{
                objectFit: "cover",
                objectPosition: "center",
              }}
            />
          </div>
          <div className="absolute inset-0 bg-gradient-to-t from-black to-transparent" />

          <div className="relative">
            <div className="w-full max-w-xl xl:mx-auto xl:w-full xl:max-w-xl xl:pr-8">
              <h3 className="text-3xl font-bold text-white">
                Join Leading CRE Capital Advisors &
                <br className="hidden xl:block" />
                Take Your Deal-Making to the Next Level
              </h3>
            </div>
          </div>
        </div>

        <div className="bg-white px-4 py-10 sm:px-6 sm:py-16 lg:px-20 lg:py-24">
          <div className="xl:mx-auto xl:w-full xl:max-w-sm 2xl:max-w-3xl">
            <h2 className="text-3xl font-bold leading-tight text-black sm:text-4xl">Try FREE for 30 days</h2>
            <p className="mt-2 text-base text-gray-600">
              Already have an account?{" "}
              <a
                href="/login"
                title="Login"
                className="font-medium text-blue-600 transition-all duration-200 hover:text-blue-700 hover:underline focus:text-blue-700"
              >
                Login
              </a>
            </p>

            <Form />

            <p className="mt-5 text-sm text-gray-600">
              This site is protected by reCAPTCHA and the Google{" "}
              <a
                href="https://policies.google.com/privacy"
                title="Privacy Policy"
                target="_blank"
                className="text-blue-600 transition-all duration-200 hover:text-blue-700 hover:underline"
                rel="noreferrer"
              >
                Privacy Policy
              </a>{" "}
              &{" "}
              <a
                href="https://policies.google.com/terms"
                title="Terms of Service"
                target="_blank"
                className="text-blue-600 transition-all duration-200 hover:text-blue-700 hover:underline"
                rel="noreferrer"
              >
                Terms of Service
              </a>
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Signup;
